import { StateCreator } from 'zustand';

import { EmployeeFormFields } from 'app/components/Employees/CreateEmployee/CreateEmployeeForm/types';

import { CreateEmployeeSlice } from './types';

const getInitialState = (companyId?: string): EmployeeFormFields => {
  return {
    companyId: companyId || '',
    firstName: '',
    lastName: '',
    email: '',
    additionalEmail: '',
    payCalendarId: '',
    startDate: '',
    externalPayrollId: '',
    annualGrossSalary: undefined,
    salaried: true,
  };
};

const createEmployeeSlice: StateCreator<CreateEmployeeSlice> = (set) => ({
  employeeData: getInitialState(),
  setEmployeeData(employeeData) {
    set((state) => ({ employeeData: { ...state.employeeData, ...employeeData } }));
  },

  resetEmployeeData() {
    set({ employeeData: getInitialState() });
  },

  initializeEmployeeData(companyId?: string) {
    set({ employeeData: getInitialState(companyId) });
  },
});

export default createEmployeeSlice;
